import { render, staticRenderFns } from "./Shippers.vue?vue&type=template&id=7d838d6a&scoped=true&"
import script from "./Shippers.vue?vue&type=script&lang=js&"
export * from "./Shippers.vue?vue&type=script&lang=js&"
import style0 from "./Shippers.vue?vue&type=style&index=0&id=7d838d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d838d6a",
  null
  
)

export default component.exports